<div class="w-full h-full flex-col gap-[20px] hidden sm:flex">
  <div class="w-full max-h-[70px] h-full flex items-center">
    <img class="max-w-[120px]" src="../../../assets/icons/secureProxy_blue.svg" alt="" />
  </div>
  <div class="h-full w-full flex flex-col justify-between mb-[20px]">
    <div class="h-fit w-full flex flex-col gap-[10px]">
      <div class="w-full" *ngFor="let navItem of navItems">
        <div
          (click)="setActiveItem(navItem.label)"
          class="w-full cursor-pointer ps-[10px] py-[10px] flex items-center gap-[8px] {{
            activeItem === navItem.label ? 'bg-[#081A46]' : null
          }} rounded-[5px]"
        >
          <img class="w-[20px] h-[20px]" [src]="getIcon(navItem)" alt="" /><span
            *ngIf="!isToggled"
            class="{{
              activeItem === navItem.label ? 'text-[#fff]' : 'text-[#081A46]'
            }} w-full"
          >
            {{ navItem.label }}</span
          >
        </div>
      </div>
    </div>
    <div
      (click)="toggleSideBar()"
      class="h-fit hidden w-full bg-[#fff] py-[10px] px-[12px] rounded-[5px] md:flex justify-between cursor-pointer"
    >
      <span *ngIf="!isToggled" class="cursor-pointer font-[500]">Toggle</span>
      <img
        class="w-[20px] h-[20px]"
        src="../../../assets/icons/right-arrow.png"
        alt=""
      />
    </div>
  </div>
</div>
<div
  *ngIf="isMobileSideNav"
  class="h-[100%] w-[300px] shadow-md fixed rounded-tr-[8px] rounded-br-[8px] left-0 p-[20px] top-0 bottom-0 bg-[#fff] z-[100]"
>
  <div class="w-full flex justify-end">
    <span (click)="closeMobileSidenav()" class="text-[20px] cursor-pointer"
      >&times;</span
    >
  </div>
  <div class="w-full flex items-center mb-[40px]">
    <img class="max-w-[120px]" src="../../../assets/icons/secureProxy_blue.svg" alt="" />
  </div>
  <div class="h-full w-full flex flex-col justify-between mb-[20px]">
    <div class="h-fit w-full flex flex-col gap-[10px]">
      <div class="w-full" *ngFor="let navItem of navItems">
        <div
          (click)="setActiveItem(navItem.label)"
          class="w-full cursor-pointer ps-[10px] py-[10px] flex items-center gap-[5px] {{
            activeItem === navItem.label ? 'bg-[#081A46]' : null
          }} rounded-[5px]"
        >
          <img class="w-[20px] h-[20px]" [src]="getIcon(navItem)" alt="" /><span
            class="{{
              activeItem === navItem.label ? 'text-[#fff]' : 'text-[#081A46]'
            }} w-full"
          >
            {{ navItem.label }}</span
          >
        </div>
      </div>
    </div>
  </div>
</div>
